interface OnePlayerProps {
    team: 'home' | 'away';
    width: string;
}

const OnePlayerEmpty = ({ team, width }: OnePlayerProps) => {

    return (
        <div className="relative">
            <div className={`h-[68px] flex flex-col justify-start items-center`}
                style={{ width: `${width}`, minWidth: `${width}` }}>
            </div>
        </div>
    )
}

export default OnePlayerEmpty;